export var cifLt = ["301 181", "<g fill='none'><path fill='#FDB913' d='M.5.5h300v180H.5z'/><path fill='#C1272D' d='M.5 90.5h300v90H.5z'/><path fill='#006A44' d='M.5 60.5h300v60H.5z'/></g>"];
